import { faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { NavMenuItem } from "interfaces/dataInterfaces"
import React, { Dispatch, MouseEvent, SetStateAction, useState } from "react"
import { Link } from "react-router-dom"

interface SidebarMenuItemProps {
  item: NavMenuItem
  depth: number
  setDepth: Dispatch<SetStateAction<number>>
  titleSection?: boolean
}

function SidebarMenuItem({ item, depth, setDepth, titleSection = true }: SidebarMenuItemProps) {
  // State
  const [isOpen, setIsOpen] = useState<boolean>(false)

  // Functions
  const handleClick = (event: MouseEvent) => {
    event.preventDefault()
    setIsOpen((prevState: boolean) => !prevState)
    if (depth > 0) {
      setDepth((prevState: number) =>
        !isOpen
          ? prevState + (item.children !== null ? item.children.length : 0)
          : prevState - (item.children !== null ? item.children.length : 0),
      )
    } else {
      setDepth((prevState: number) => prevState + (item.children !== null ? item.children.length : 0))
    }
  }

  const sidebarChildren = (element: NavMenuItem) => (
    <ul
      className={`sidebar-menu--list sidebar-menu--tree${isOpen ? " menu-open" : " menu-close"}`}
      style={{ height: isOpen ? `${36 * depth}px` : "0" }}
    >
      {element.children?.map((subItem: NavMenuItem, index: number) => (
        <Link to={subItem?.link || "#"} key={`${index}-${subItem.text}`}>
          <li className="sidebar-menu--item">
            <span>
              {subItem?.icon && (
                <FontAwesomeIcon
                  /*  @ts-ignore  */
                  icon={subItem?.icon.includes("files-o") ? "fa-copy" : subItem.icon}
                  /*  size="sm" */
                  className="mr-1 fs-14"
                />
              )}
              {!subItem?.children?.length ? subItem?.text : null}
            </span>
          </li>
        </Link>
      ))}
    </ul>
  )

  return (
    <>
      <span
        aria-hidden
        onClick={handleClick}
        className={`${isOpen ? "svg-open" : "svg-close"} ${titleSection ? "section" : ""}`}
      >
        <Link to={item?.link || "#"}>
          {item?.icon && (
            <FontAwesomeIcon
              /*  @ts-ignore  */
              icon={item?.icon}
              className="mr-1"
              size="lg"
              style={{ minWidth: "2rem" }}
            />
          )}
          {item?.text}
        </Link>

        {item?.children?.length ? <FontAwesomeIcon icon={faAngleRight} className="arrow-svg" /> : null}
      </span>

      {item?.children?.length ? sidebarChildren(item) : null}
    </>
  )
}

export default SidebarMenuItem
